import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { api, setToken, getToken } from "../../lib/api";
import { Truck, LogOut, FileText, Mail, FileEdit } from "lucide-react";
import { toast } from "sonner";

export function RequireAdmin({ children }) {
  const nav = useNavigate();
  const loc = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      nav("/admin/login", { replace: true });
      return;
    }
    api
      .get("/auth/me")
      .then(() => setChecking(false))
      .catch(() => {
        toast.error("Session expired. Please sign in again.");
        nav("/admin/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.pathname]);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#122A1E] text-[#F4F4F1] flex items-center justify-center font-mono-accent text-sm">
        Verifying…
      </div>
    );
  }
  return children;
}

export default function AdminLayout() {
  const nav = useNavigate();
  const loc = useLocation();

  const logout = () => {
    setToken(null);
    nav("/admin/login");
  };

  const linkCls = (path) =>
    `font-mono-accent text-[11px] uppercase px-3 py-2 border-2 ${
      loc.pathname.startsWith(path)
        ? "bg-[#FF5A00] text-white border-[#FF5A00]"
        : "border-transparent text-[#F4F4F1] hover:bg-[#0C1D14]"
    }`;

  return (
    <div className="min-h-screen bg-[#F4F4F1]" data-testid="admin-layout">
      <header className="bg-[#122A1E] text-[#F4F4F1] border-b-2 border-[#0C1D14]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/admin/blog" className="flex items-center gap-2" data-testid="admin-logo">
            <div className="w-9 h-9 bg-[#FF5A00] flex items-center justify-center">
              <Truck size={18} />
            </div>
            <div>
              <div className="font-display font-black uppercase tracking-tighter text-sm">
                M&R Dispatch Console
              </div>
              <div className="font-mono-accent text-[9px] text-[#F4F4F1]/60">
                ADMIN · {window.location.host}
              </div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            <Link to="/admin/blog" className={linkCls("/admin/blog")} data-testid="admin-nav-blog">
              <FileText size={12} className="inline mr-1" /> Blog
            </Link>
            <Link to="/admin/quotes" className={linkCls("/admin/quotes")} data-testid="admin-nav-quotes">
              <FileEdit size={12} className="inline mr-1" /> Quotes
            </Link>
            <Link to="/admin/contacts" className={linkCls("/admin/contacts")} data-testid="admin-nav-contacts">
              <Mail size={12} className="inline mr-1" /> Contacts
            </Link>
          </nav>
          <button
            onClick={logout}
            className="inline-flex items-center gap-2 border-2 border-[#F4F4F1]/30 hover:border-[#FF5A00] px-3 py-2 font-mono-accent text-[11px] uppercase"
            data-testid="admin-logout"
          >
            <LogOut size={12} /> Sign out
          </button>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">
        <Outlet />
      </main>
    </div>
  );
}
